import IClaimDetails from 'models/ClaimDetails';

import { ReduxStore } from 'store/types';

function getDetailsClaimInfo(state: ReduxStore): IClaimDetails | null {
  return state.intervention.getDetails.claimInfo;
}

export default getDetailsClaimInfo;
